// state
const state =  {
  
};

// actions
const actions = {
  
}

// mutations
const mutations = {
  
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}